import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {CountryCodeService} from 'src/app/services';

@Component({
    selector: 'app-country-code',
    templateUrl: './country-code.component.html',
    styleUrls: ['./country-code.component.scss']
})
export class CountryCodeComponent implements OnInit {
    countryCodes = [];
    @Output() valueChange = new EventEmitter();
    @Input() initCC: boolean;
    @Input() control = new UntypedFormGroup({countryCode: new UntypedFormControl('', Validators.required)});


    _selectedCountry = '1';
    initialized = false;

    constructor(private countryCodeService: CountryCodeService) {
    }

    ngOnInit() {
        this.countryCodeService.getAllCountryCodes().subscribe(countryCodes => {
            this.countryCodes = countryCodes.map(cc => {
                return {phone_code: cc.phone_code, country: cc.country};
            });
            this.initialized = true;
        });

    }

    get selectedCountry(): string {
        return this._selectedCountry;
    }

    @Input()
    set value(cc: string) {
        this.countryCodeHelper(cc);
    }

    set selectedCountry(cc: string) {
        this.countryCodeHelper(cc);
    }

    countryCodeHelper(cc: string) {
        if (!this.countryCodes.length) {
            this._selectedCountry = cc;
        } else {
            this._selectedCountry = this.countryCodes.map(cCode => cCode.phone_code + '').find(cCNum => cCNum === cc) || '   ';
            this.valueChange.emit(this._selectedCountry);
        }
    }

    getSelectedCountry(): string {
        if (this.initCC) {
            this._selectedCountry = this.countryCodes.map(cCode => cCode.phone_code + '').find(cCNum => cCNum === '1') || '   ';
            this.valueChange.emit(this._selectedCountry);
            this.initCC = false;
        }
        return this.selectedCountry;
    }
}
